export interface DeletionRequest {
  requested: number;      // Timestamp
  triggered: number;      // Timestamp
  executed: number;       // Timestamp
  cancelled: number;      // Timestamp
  created: number;        // Timestamp
  currentStatus: string;
}
